// extracted by mini-css-extract-plugin
export default {"switch":"Switchbx_switch__SJmM+","label":"Switchbx_label__Tfkqx","switch-text":"Switchbx_switch-text__+2uOL"};